/* screens/academy/clipboard.js — копирование в буфер с фолбэком.

   navigator.clipboard есть не везде (не-https, старые webview, iframe без
   разрешения): без фолбэка методист «скопировал» бы пустоту и разослал битую
   ссылку, не узнав об этом. Возвращаем признак успеха — вызывающий обязан
   показать саму строку, если скопировать не удалось.

   Общий для «Публичного адреса курса» (CourseEditor) и «Ссылки на оплату»
   (OrdersTab): обе поверхности раздают ссылку человеку наружу. */

export async function writeClipboard(text) {
  const value = String(text == null ? '' : text);
  if (!value) return false;
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch { /* нет разрешения — пробуем фолбэк */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
